import React from "react";
import { address_brand_kr, address_lab_kr, factory_1_kr, factory_2_kr } from "../../field";
import { DATA_EMAIL } from "../items/ContactEmail";

const _dataInfo = [
	{
		id: 1,
		label: "time",
		contents: [
			{
				title: "운영시간",
				text: ["평일 오전 9:00 ~ 오후 16:00", "*점심시간 오후 12:30 ~ 13:30", "*주말 및 공휴일 휴무"],
			},
		],
	},
	{
		id: 2,
		label: "tel",
		contents: [
			{
				title: "대표 전화번호",
				text: ["070-4282-9626"],
			},
		],
	},
	{
		id: 3,
		label: "location",
		contents: [
			{
				title: "제 1 공장",
				text: [factory_1_kr],
			},
			{
				title: "제 2 공장",
				text: [factory_2_kr],
			},
			{
				title: "기업부설연구소",
				text: [address_lab_kr],
			},

			{
				title: "브랜드사",
				text: [address_brand_kr],
			},
		],
	},
	{
		id: 4,
		label: "email",
		contents: [
			{
				title: "이메일",
				data: DATA_EMAIL,
			},
		],
	},
];

const CustomerInfo = (props) => {
	return (
		<section className={`CustomerInfo ${props.className}`}>
			<div className="con">
				<ul className="wrap-info">
					{_dataInfo.map((el) => {
						return (
							<li key={el.id} className={`${el.label} list-customerInfo`}>
								{el.contents.map((con) => {
									return (
										<div className="customerInfo-contents" key={con.title}>
											<div className="customerInfo-header">
												<p>{con.title}</p>
											</div>
											<div className="customerInfo-body">
												{con.title !== "이메일"
													? con.text.map((info, index) => {
															return <p key={index}>{info}</p>;
													  })
													: con.data.map((email, index) => {
															return (
																<p className="email" key={index}>
																	<span className="key">{email.keyText}</span>
																	<span className="value">
																		<a href={`mailto:${email.valueText}`}>{email.valueText}</a>
																	</span>
																</p>
															);
													  })}
											</div>
										</div>
									);
								})}
							</li>
						);
					})}
				</ul>
			</div>
		</section>
	);
};

export default CustomerInfo;
